import { ref, watch, onMounted, onBeforeUnmount } from 'vue';

export default function useVisibility(options = {}) {
  const target = ref(null);
  const isVisible = ref(false);
  let observer;

  onMounted(() => {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      isVisible.value = true;
      return;
    }

    observer = new IntersectionObserver(
      ([entry]) => {
        isVisible.value = !!entry?.isIntersecting;
      },
      { threshold: 0.1, ...options },
    );

    watch(
      target,
      (el, prev) => {
        try {
          if (prev) observer.unobserve(prev);
          if (el) observer.observe(el);
        } catch (e) {
          console.log(e);
        }
      },
      { immediate: true },
    );
  });

  onBeforeUnmount(() => {
    try {
      if (observer) observer.disconnect();
    } catch (e) {
      console.log(e);
    }
    observer = undefined;
  });

  return { target, isVisible };
}
